const FULL_ACCESS_ROLES = [
  "admin",
  "administrator",
  "owner",
  "superadmin",
  "superadministrator"
];

export function normalizeRole(role) {
  return String(role || "")
    .trim()
    .toLowerCase()
    .replace(/[\s_-]+/g, "");
}

export function getUserRole(user = {}) {
  return normalizeRole(
    user.status ||
      user.role ||
      user.level ||
      user.jabatan ||
      user.user_level ||
      ""
  );
}

export function hasFullMenuAccess(user = {}) {
  return FULL_ACCESS_ROLES.includes(getUserRole(user));
}

export function normalizePermissionPath(path) {
  const clean = String(path || "").replace(/\/$/, "");
  return clean || "/";
}

export function requiresExplicitPermission(path) {
  return ["/dashboard-owner"].includes(normalizePermissionPath(path));
}
